export const cvData = {
  personalInfo: {
    nombre: "DAVID FREDY POVIS QQUECCAÑO",
    titulo: "Practicante de Ingeniería Industrial | Tercio Superior - 8.° Ciclo | UNMSM",
    email: "david.povis@unmsm.edu.pe",
    telefono: "944507095",
    ubicacion: "Lima, Perú",
    linkedin: "linkedin.com/in/dpovi",
    github: "portafolio.dpovi.me",
    portfolio: ""
  },
  
  resumenProfesional: "Estudiante de Ingeniería Industrial en la UNMSM (Tercio Superior, 8.° ciclo) con formación integral en gestión de operaciones, mejora continua, control de calidad, logística y seguridad ocupacional. Certificado en Power BI, SQL y Excel Avanzado. Experiencia práctica en coordinación de eventos con SUNAFIL en el marco de Seguridad y Salud en el Trabajo. Orientado a resultados, con habilidades analíticas y capacidad para trabajar bajo presión. Disponibilidad inmediata para prácticas en producción, calidad, logística, SST, procesos o áreas afines.",
  
  experiencia: [
    {
      puesto: "Asistente de Coordinación - Seguridad y Salud en el Trabajo",
      empresa: "SUNAFIL - Superintendencia Nacional de Fiscalización Laboral",
      ubicacion: "Lima, Perú",
      fechaInicio: "Jun 2023",
      fechaFin: "Jul 2023",
      logros: [
        "Coordiné logística y registro de +100 asistentes en conferencia de SST",
        "Apoyé en planificación y ejecución del evento 'Aspectos básicos de Seguridad y Salud en el Trabajo'",
        "Elaboré reportes de asistencia y evaluación de satisfacción post-evento",
        "Desarrollé habilidades en normativa SST peruana (Ley 29783) y gestión de eventos corporativos"
      ],
      tecnologias: ""
    }
  ],
  
  proyectos: [
    {
      nombre: "Optimización de Línea de Producción",
      descripcion: "Estudio de tiempos y movimientos con reducción del 15% en tiempos de ciclo aplicando Lean Manufacturing y 5S"
    },
    {
      nombre: "Dashboard de KPIs Operacionales",
      descripcion: "Tablero en Power BI para monitoreo de OEE, productividad, calidad y eficiencia con actualización automática"
    },
    {
      nombre: "Plan IPER y Mejora de Condiciones SST",
      descripcion: "Identificación de peligros y evaluación de riesgos según Ley 29783, con propuestas de control implementadas"
    },
    {
      nombre: "Sistema de Control de Inventarios",
      descripcion: "Modelo ABC y análisis de rotación en Excel con macros para optimización de almacén y reducción de costos"
    }
  ],
  
  educacion: [
    {
      titulo: "Ingeniería Industrial (8.° Ciclo - Tercio Superior)",
      institucion: "Universidad Nacional Mayor de San Marcos (UNMSM)",
      ubicacion: "Lima, Perú",
      fechaInicio: "2021",
      fechaFin: "Presente",
      cursosRelevantes: "Investigación de Operaciones, Gestión de Calidad Total, Ingeniería de Métodos, Planificación y Control de Producción, Logística y Cadena de Suministro, Seguridad Industrial, Estadística Aplicada, Costos Industriales"
    },
    {
      titulo: "Programa de Inglés",
      institucion: "Asociación Cultural Peruano Británica",
      ubicacion: "Lima, Perú",
      fechaInicio: "2024",
      fechaFin: "Presente",
      cursosRelevantes: ""
    }
  ],
  
  habilidades: {
    tecnicas: [],
    blandas: []
  },

  habilidadesPorCategoria: {
    frontend: "Excel Avanzado (Macros/VBA), Tablas Dinámicas, Power BI, DAX, Google Sheets",
    backend: "SQL, Power Query, Análisis Estadístico, Minitab, SPSS",
    basesdatos: "SAP (módulos MM/PP básico), Microsoft Office 365, Google Workspace, ERP",
    herramientas: "AutoCAD 2D, MS Visio, Bizagi (BPMN), MS Project, Diagramas de Flujo, Ishikawa, Pareto",
    metodologias: "Lean Manufacturing, Six Sigma (DMAIC), 5S, Kaizen, PDCA, TPM, Kanban, Estudio de Tiempos y Movimientos, Balanceo de Líneas"
  },
  
  certificaciones: [
    {
      nombre: "Power BI - Data Analyst",
      institucion: "Microsoft",
      fecha: "Jun 2025"
    },
    {
      nombre: "SQL Associate",
      institucion: "DataCamp",
      fecha: "Sep 2025"
    },
    {
      nombre: "Excel Avanzado",
      institucion: "Interbank",
      fecha: "Feb 2025"
    },
    {
      nombre: "English for IT 1",
      institucion: "Cisco",
      fecha: "Oct 2025"
    }
  ],
  
  idiomas: [
    { idioma: "Español", nivel: "Nativo" },
    { idioma: "Inglés", nivel: "Intermedio (B1)" }
  ],

  infoAdicional: {
    disponibilidad: "Inmediata - Tiempo completo o medio tiempo",
    softSkills: "Liderazgo, Trabajo en equipo, Comunicación efectiva, Pensamiento analítico, Orientación a resultados, Trabajo bajo presión, Proactividad"
  }
};
